<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to previous page" @click="backToSummary">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="workshift-plan" color="white"></help-link>
                    <v-btn dark class="primary" @click="showAddTeamPlan">
                        Create Team Plan
                    </v-btn>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>
            <v-card v-if="!loading" class="elavation-1 mt-5"> 
               <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" :label="searchLabel" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon small title="View previous week"  @click="viewPrevious" class="mr-10" :disabled="loading||disablePrev">
                        <v-icon>chevron_left</v-icon>
                    </v-btn>
                    <b>{{weekCoverageDesc.from}} to {{weekCoverageDesc.to}}</b>
                    <v-btn icon small title="View next week" @click="viewNext" :disabled="loading||disableNext">
                        <v-icon>chevron_right</v-icon>
                    </v-btn>  
                </v-toolbar>
                <v-data-table
                    :headers="tableHeader"
                    :items="users_data_filtered"
                    :loading="loading"
                    hide-actions
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">

                        <!-- hasTeamEditRights -->
                        <tr v-if="hasTeamEditRights">
                            <td>
                                <v-chip>
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}} 
                                </v-chip>
                            </td>
                            <td class="workshift-box" :style="`background-color:${getWorshiftData(1, props.item.userId).color}`" :title="getWorshiftData(1, props.item.userId).title" @click="displayAddEdit(props.item, 1, getWorshiftData(1, props.item.userId).workShiftId)">
                                <div>{{ getWorshiftData(1, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box" :style="`background-color:${getWorshiftData(2, props.item.userId).color}`" :title="getWorshiftData(2, props.item.userId).title" @click="displayAddEdit(props.item, 2, getWorshiftData(2, props.item.userId).workShiftId)">
                                <div>{{ getWorshiftData(2, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box" :style="`background-color:${getWorshiftData(3, props.item.userId).color}`" :title="getWorshiftData(3, props.item.userId).title" @click="displayAddEdit(props.item, 3, getWorshiftData(3, props.item.userId).workShiftId)">
                                <div>{{ getWorshiftData(3, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box" :style="`background-color:${getWorshiftData(4, props.item.userId).color}`" :title="getWorshiftData(4, props.item.userId).title" @click="displayAddEdit(props.item, 4, getWorshiftData(4, props.item.userId).workShiftId)">
                                <div>{{ getWorshiftData(4, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box" :style="`background-color:${getWorshiftData(5, props.item.userId).color}`" :title="getWorshiftData(5, props.item.userId).title" @click="displayAddEdit(props.item, 5, getWorshiftData(5, props.item.userId).workShiftId)">
                                <div>{{ getWorshiftData(5, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box" :style="`background-color:${getWorshiftData(6, props.item.userId).color}`" :title="getWorshiftData(6, props.item.userId).title" @click="displayAddEdit(props.item, 6, getWorshiftData(6, props.item.userId).workShiftId)">
                                <div>{{ getWorshiftData(6, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box" :style="`background-color:${getWorshiftData(7, props.item.userId).color}`" :title="getWorshiftData(7, props.item.userId).title" @click="displayAddEdit(props.item, 7, getWorshiftData(7, props.item.userId).workShiftId)">
                                <div>{{ getWorshiftData(7, props.item.userId).timeRange }}</div>
                            </td>
                        </tr>

                        <!-- no TeamEditRights -->
                        <tr v-else>
                            <td>
                                <v-chip>
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}} 
                                </v-chip>
                            </td>
                            <td class="workshift-box-no-edit" :style="`background-color:${getWorshiftData(1, props.item.userId).color}`">
                                <div>{{ getWorshiftData(1, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box-no-edit" :style="`background-color:${getWorshiftData(2, props.item.userId).color}`">
                                <div>{{ getWorshiftData(2, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box-no-edit" :style="`background-color:${getWorshiftData(3, props.item.userId).color}`">
                                <div>{{ getWorshiftData(3, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box-no-edit" :style="`background-color:${getWorshiftData(4, props.item.userId).color}`">
                                <div>{{ getWorshiftData(4, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box-no-edit" :style="`background-color:${getWorshiftData(5, props.item.userId).color}`">
                                <div>{{ getWorshiftData(5, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box-no-edit" :style="`background-color:${getWorshiftData(6, props.item.userId).color}`">
                                <div>{{ getWorshiftData(6, props.item.userId).timeRange }}</div>
                            </td>
                            <td class="workshift-box-no-edit" :style="`background-color:${getWorshiftData(7, props.item.userId).color}`">
                                <div>{{ getWorshiftData(7, props.item.userId).timeRange }}</div>
                            </td>
                        </tr>

                    </template>
                    <template v-slot:footer>
                        <tr class="font-weight-bold">
                            <td>Total</td>
                            <td>
                                <v-avatar size="20" small v-for="(item,index) in getWorshiftTotal(1)" :key="index" :color="item.color" class="workshift-total">
                                    {{ item.count }}
                                </v-avatar>
                            </td>
                            <td>
                                <v-avatar size="20" small v-for="(item,index) in getWorshiftTotal(2)" :key="index" :color="item.color" class="workshift-total">
                                    {{ item.count }}
                                </v-avatar>
                            </td>
                            <td>
                                <v-avatar size="20" small v-for="(item,index) in getWorshiftTotal(3)" :key="index" :color="item.color" class="workshift-total">
                                    {{ item.count }}
                                </v-avatar>
                            </td>
                            <td>
                                <v-avatar size="20" small v-for="(item,index) in getWorshiftTotal(4)" :key="index" :color="item.color" class="workshift-total">
                                    {{ item.count }}
                                </v-avatar>
                            </td>
                            <td>
                                <v-avatar size="20" small v-for="(item,index) in getWorshiftTotal(5)" :key="index" :color="item.color" class="workshift-total">
                                    {{ item.count }}
                                </v-avatar>
                            </td>
                            <td>
                                <v-avatar size="20" small v-for="(item,index) in getWorshiftTotal(6)" :key="index" :color="item.color" class="workshift-total">
                                    {{ item.count }}
                                </v-avatar>
                            </td>
                            <td>
                                <v-avatar size="20" small v-for="(item,index) in getWorshiftTotal(7)" :key="index" :color="item.color" class="workshift-total">
                                    {{ item.count }}
                                </v-avatar>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
            
            <!-- Comments and Updates -->
            <v-layout row wrap class="mt-5">
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" ref="commentsRef" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    
        <v-dialog v-model="dialogAddTeamPlan" persistent width="600">
            <add-team-plan ref="addTeamPlan" :dialogAddTeamPlan.sync="dialogAddTeamPlan" @send="getWorkshiftsPlan(false)"></add-team-plan>
        </v-dialog>
        <v-dialog v-model="dialogWorkShiftPlan" persistent width="600">
            <add-edit-plan ref="addEditPlan" :dialogWorkShiftPlan.sync="dialogWorkShiftPlan" @send="getWorkshiftsPlan(false)"></add-edit-plan>
        </v-dialog>

        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{snackbarText}}
            <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    </v-layout> 
</template>

<script>

import workshiftsplanApi from '@/api/workshiftsplan'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import AppPageID from '@/constants/app_page_ids'
import { hasTeamEditRights } from '@/helpers/myteams-permissions'

export default {     
    name: 'WorkshiftsPlanDetails',
    metaInfo: {
        title: 'Workshifts Plan Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Workshifts Plan Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'add-edit-plan': () => import('@/components/WorkShiftPlan/AddEditWorkShiftPlan'),
        'add-team-plan': () => import('@/components/WorkShiftPlan/AddTeamPlan'),
    },   
    data () {
        return {
            awsS3Helper,
            search: userPrefs.getSearchKeyword(this.$route.name),
            error: false,
            errorMessage: '',
            loading: false,
            snackbar: false,
            snackbarText: '',
            mode: null,
            x: null,
            y: null,
            toggle_view: 0,
            dialogWorkShiftPlan: false,
            dialogAddTeamPlan: false,
            menu_status: false,
            header_data: null,
            users_data: [],
            attendance_data: [],
            attendance_corrections_data: [],
            workshifts_data: [],
            selectedWeekNo: null
        }
    },
    methods: {
        showAddTeamPlan() {
            const data = {
                pageKey: this.pageKey,
                teamId: this.teamId,
                fiscalYear: this.selectedFiscalYear,
            }
            this.$refs.addTeamPlan.setData(data)
            this.dialogAddTeamPlan = true
        },
        backToSummary() {
            this.$router.push('/myteam/workshiftplan')
        },
        displayAddEdit(data, day, workShiftId) {
            const transDate = this.header_data
                                    .filter(x => x.day == day)[0].transDate
            const workShiftsPlan = this.workshifts_data.filter(x => {
                return x.userId == data.userId && x.transDate == transDate
            })
            
            if (this.hasAttendance(data, day)) {
                this.snackbarText = 'Attendance has already been recorded for this date'
                this.snackbar = true
                return
            }
            if (this.hasAttendanceCorrections(data, day)) {
                this.snackbarText = 'An attendance correction already exists for this date'
                this.snackbar = true
                return
            }

            const param = {
                pageKey: this.pageKey,
                workShiftsPlanId: workShiftsPlan.length ? workShiftsPlan[0].workShiftsPlanId: 0,
                teamId: this.teamId,
                fiscalYear: this.selectedFiscalYear,
                weekNumber: this.selectedWeekNo,
                workShiftId: workShiftId,
                startDate: transDate,
                endDate: transDate,
                userId: data.userId,
                firstName: data.firstName,
                lastName: data.lastName,
                avatar: data.avatar
            }
            this.$refs.addEditPlan.setUserData(param)
            this.dialogWorkShiftPlan = true
        },
        hasAttendance(data, day) {
            const transDate = this.header_data
                                .filter(x => x.day == day)[0].transDate
            const attendance = this.attendance_data
                                .filter(x => x.userId == data.userId && this.$moment(x.transDate).format('MMM DD, YYYY') == this.$moment(transDate).format('MMM DD, YYYY'))
            return attendance.length
        },
        hasAttendanceCorrections(data, day) {
            const transDate = this.header_data
                                .filter(x => x.day == day)[0].transDate
            const attendance_corrections = this.attendance_corrections_data
                                                .filter(x => x.userId == data.userId && this.$moment(x.transDate).format('MMM DD, YYYY') == this.$moment(transDate).format('MMM DD, YYYY'))
            return attendance_corrections.length
        },
        getWorshiftData(day, userId) {
            const transDate = this.header_data.filter(x => x.day == day)[0].transDate
            const details = this.workshifts_data
                                .filter(x => x.userId == userId && x.transDate == transDate)
            if (details.length > 0) {
                return {
                    workShiftId: details[0].workShiftId,
                    color: details[0].color,
                    title: details[0].workShift,
                    timeRange: this.$moment(details[0].clockStart).format('h:mma') +'-'+ this.$moment(details[0].clockEnd).format('h:mma')
                }
            } else {
                return {
                    workShiftId: null,
                    color: 'transparent',
                    title: 'No schedule, click to add workshift plan',
                    timeRange: ''
                }
            }
        },
        getWorshiftTotal(day){
            const transDate = this.header_data.filter(x => x.day == day)[0].transDate
            const colorCounts = this.workshifts_data
                                    .filter(x => x.transDate == transDate)
                                    .reduce((acc, item) => {
                                        if (item.color) {
                                            if (!acc[item.color]) {
                                                acc[item.color] = 1;
                                            } else {
                                                acc[item.color]++;
                                            }
                                            }
                                            return acc;
                                    }, {});

            return Object.keys(colorCounts).map(color => ({
                color,
                count: colorCounts[color]
            }));
        },
        async viewPrevious() {
            this.selectedWeekNo--
            this.$router.push(`/myteam/workshiftplan/${this.selectedFiscalYear}/${this.selectedWeekNo}`)

            await this.getWorkshiftsPlan(false)

            // the following code are required only if navigating to data where components are not recreated
            // example: navigating to different date transactions using the same page/components
            this.$refs.updateHistoryRef.getHistory()
            this.$refs.commentsRef.invokeSubscribe()
            this.$refs.commentsRef.getCommentsHistory()
        },
        async viewNext() {
            this.selectedWeekNo++
            this.$router.push(`/myteam/workshiftplan/${this.selectedFiscalYear}/${this.selectedWeekNo}`)

            await this.getWorkshiftsPlan(false)

            // the following code are required only if navigating to data where components are not recreated
            // example: navigating to different date transactions using the same page/components
            this.$refs.updateHistoryRef.getHistory()
            this.$refs.commentsRef.invokeSubscribe()
            this.$refs.commentsRef.getCommentsHistory()
        },
        async getWorkshiftsPlan(show_loading) {
            try {
                this.loading = show_loading
                var data = {
                    fiscalYear: this.selectedFiscalYear,
                    weekNo: this.selectedWeekNo
                }
                const response = await workshiftsplanApi.getWeeklyDetails(data)
                if (response && response.status == 200) {
                    this.header_data = response.data.header
                    this.users_data = response.data.users
                    this.workshifts_data = response.data.details
                    this.attendance_data = response.data.attendance
                    this.attendance_corrections_data = response.data.attendanceCorrections
                }
                this.loading = false
            } catch (error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async updateHandler(data) {
            await this.getWorkshiftsPlan(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.$store.state.selectedTeamName} WorkShift Plan`
        })
        
        this.selectedWeekNo = this.$route.params.weekNo
        this.getWorkshiftsPlan(true)
    },
    watch: {
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        hasTeamEditRights() {
            return hasTeamEditRights(AppPageID.TeamWorkshiftPlan)
        },        
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.workshifts_plan,
                    notificationTypeId: notificationTypes.workshifts
                }
            }
        },
        selectedFiscalYear() {
            return this.$route.params.fiscalYear
        },
        disablePrev() {
            if (!this.loading) {
                return this.$moment(this.header_data[0].transDate).year() < this.$route.params.fiscalYear
            }
        },
        disableNext() {
            if (!this.loading) {
                return this.$moment(this.header_data[this.header_data.length-1].transDate).year() > this.$route.params.fiscalYear
            }
        },
        weekCoverageDesc() {
            if (!this.loading)
                if (this.isMobile) {
                    return {
                        from: this.$moment(this.header_data[0].transDate).format('MMM D'),
                        to: this.$moment(this.header_data[this.header_data.length-1].transDate).format('D, YYYY')
                    }
                }else{
                    return {
                        from: this.$moment(this.header_data[0].transDate).format('MMM DD, YYYY'),
                        to: this.$moment(this.header_data[this.header_data.length-1].transDate).format('MMM DD, YYYY')
                    }
                }
        },
        lockedPeriod() {
            if (!this.loading)
                return this.trans_dates.filter(x => {
                    return x.isEditable==1
                }).length==0
        },
        noData() {
            if (!this.loading)
                return this.task.details==null || this.task.details.length==0
        },
        tableHeader(){
            var headerData = []
            headerData.push(
                {
                    text: 'Employees', 
                    align:'left', 
                    value:'lastName', 
                    width:'45%', 
                    sortable:true
                },
            )
            this.header_data.forEach(item => {
                headerData.push(
                    {
                        text: this.$moment(item.transDate).format('ddd DD'), 
                        align:'center', 
                        value: '', 
                        width:'', 
                        sortable:false
                    },
                )
            })
            return headerData
        },
        users_data_filtered() {
            var temp = this.users_data
            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return item.firstName.toLowerCase().includes(this.search.toLowerCase()) || 
                            item.lastName.toLowerCase().includes(this.search.toLowerCase())
                })
            }
            return temp
        },
        teamId() {
            return this.$store.state.selectedTeamId
        },
        pageQueryId() {
            return `workshiftsplan-${this.$store.state.companyId}-${this.teamId}-${this.selectedFiscalYear}-${this.selectedWeekNo}`
        },
        isMobile() {
            return window.innerWidth < 600  //make this global
        },
        searchLabel() {
            return this.isMobile ? 'Search' : 'Search employee name'
        }
    }
}
</script>
<style scoped>
.workshift-box-no-edit {
    font-size: 11px;
    border: 1px solid lightgray;
}
.workshift-box-no-edit > div {
    text-align: center;
}
.workshift-box {
    cursor: pointer;
    font-size: 11px;
    border: 1px solid lightgray;
}
.workshift-box:hover {
    text-decoration: underline;
}
.workshift-box > div {
    text-align: center;
}
.workshift-total {
    font-size: 10px;
}
</style>